import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import '../styles/plastic.css'; // Assuming you are already using a custom CSS file
import Tws1 from '../assets/images/tws1.jpg';
import Tws2 from '../assets/images/tws2.jpg';
import Tws3 from '../assets/images/tws3.jpg';
import Tws4 from '../assets/images/tws4.jpg';
import Tws5 from '../assets/images/tws5.jpg';
import Tws6 from '../assets/images/tws6.jpg';
import Tws7 from '../assets/images/tws7.jpg';
import Tws8 from '../assets/images/tws8.jpg';
import Tws9 from '../assets/images/tws9.jpg';

const Tws = () => {
  const [customStyle, setCustomStyle] = useState(false); // Track the style toggle

  const images = [
    Tws1,
    Tws2,
    Tws3,
    Tws4,
    Tws5,
    Tws6,
    Tws7,
    Tws8,
    Tws9,
  ];

  // Toggle custom styling
  const switchStyle = () => {
    setCustomStyle(!customStyle);
  };

  return (
    < div >
      <section className="about-container"> <h1>TWS</h1></section>
     <br/><br/>
       <div className="acer-container">
      {/* Gallery with hover animation */}
      <div className={`row ${customStyle ? "hover-effect-2" : "hover-effect-1"}`} id="gallery">
        {images.map((src, index) => (
          <div className="col-12 col-sm-6 col-lg-4 mb-4" key={index}>
            <img
              className="w-100 hover-img"
              src={src}
              alt={`Slide ${index + 1}`}
            />
          </div>
        ))}
      </div>
    </div></div>
  );
};

export default Tws;
